import { Dropdown, type MenuProps } from "antd";
import { properties } from "../../../../entities/properties";
import type { EntityLinksDropdownType } from "./EntityLinksDropdownType";

const EntityLinksDropdown: React.FC<EntityLinksDropdownType> = ({ material, children }) => {

    const menuItems: MenuProps['items'] = [
        {
            key: 'workbench',
            label: (
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${properties.analyticsLink}/projects/6295c7173ae8947d89af2c73/min-max-material-analysis?material=${material}`}>
                    Workbench
                </a>
            ),
        },
        {
            key: 'inventory',
            label: (
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${properties.ihLink}/data?operator=Client&material=${material}`}>
                    Inventory
                </a>
            ),
        },
    ]

    return <Dropdown overlayStyle={{ zIndex: 900 }}  menu={{ items: menuItems }}>{children}</Dropdown>;
}

export default EntityLinksDropdown;